export const isPhone = (value) => {
  const reg = /1[3-9]\d{9}/
  return reg.test(value)
}
export const isTel = (value) => {
  const reg = new RegExp('(\\d{3,4}-)?\\d{7,8}')
  return reg.test(value)
}
export const isEmail = (value) => {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(value)
}